document.addEventListener('DOMContentLoaded', () => {
    const desktopLinks = document.querySelectorAll('.template-program-details__degree-type a');
    const dropdown = document.getElementById('customDropdownMobile');

    if (!dropdown || desktopLinks.length === 0) return;

    const toggleBtn = dropdown.querySelector('.template-program-details__dropdown-toggle') as HTMLButtonElement;
    const selectedText = dropdown.querySelector('.selected-text') as HTMLElement;
    const menu = dropdown.querySelector('.template-program-details__dropdown-menu') as HTMLUListElement;

    // Populate custom dropdown from desktop links
    desktopLinks.forEach(link => {
        const li = document.createElement('li');
        li.textContent = link.textContent ?? '';
        li.dataset.href = link.getAttribute('href') ?? '#';

        if (link.classList.contains('active')) {
            selectedText.textContent = link.textContent ?? 'Select';
        }

        li.addEventListener('click', () => {
            li.dataset.href && window.location.assign(li.dataset.href);
        });

        menu.appendChild(li);
    });

    // Toggle open/close
    toggleBtn.addEventListener('click', () => {
        dropdown.classList.toggle('open');
    });

    // Close on outside click
    document.addEventListener('click', (e) => {
        if (!dropdown.contains(e.target as Node)) {
            dropdown.classList.remove('open');
        }
    });
});